<template>
    <ModalFormCard :action="action" class="modal-default wide" v-bind="{ errors, saving }">
        <template #title>{{ isEdit ? 'Edit' : 'New' }} email</template>

        <input v-if="options?.replyId" type="hidden" name="reply_id" :value="options.replyId" />

        <Select
            v-model:value="value.sent_to_email_address"
            :options="numberOptions"
            groupClass="bg-white text-15"
            label="Send to"
            name="sent_to_email_address"
            placeholder="Select email address"
        >
            <template #option="{ option, selected }">
                {{ option.html }}
                <!-- {{ option.value }}
                {{ parseInt(option.id) == primaryEmailId && !selected ? ' - PRIMARY' : '' }} -->
            </template>
        </Select>

        <input type="hidden" name='send_to_user_id' :value='numberOptions.find(n => n.value == value.sent_to_email_address)?.id' />

        <Select
            v-model:value="value.template_id"
            :disabled="templates == null || templates.length == 0"
            :options="templates != null ? templates.map(t => {
                return {
                    html: t.name,
                    value: t.id
                }
            }) : []"
            groupClass="bg-white text-15"
            label="Template"
            name="template_id"
            placeholder="Select a template"
            class="mt-4"
            @update:value='setTemplate'
        />

        <Input
            v-model:value="value.subject"
            class="input-white mt-4"
            label="Subject"
            name="subject"
            placeholder="Add subject"
            :limit="modelType == 2 ? null : 30"
        />

        <Textarea
            v-model:value="value.body"
            v-show="value.template_id == null"
            :disabled="saving"
            class="transition-all duration-500 ease-in-out mt-4"
            label="Email body"
            name="body"
            placeholder="Start typing…"
            rows="6"
        >
            <!-- <template #limit="{ value, length, limit }"
                >{{ length }} / 160
                <template v-if="length < limit">({{ Math.ceil(length / 160) }} {{ $help.pluralize('message', Math.ceil(length / 160)) }})</template>
                <template v-else>(1,600 characters max, remove characters)</template>
            </template> -->
        </Textarea>

        <DropdownV2 :menuSpace="8" class="mt-4" v-if="value.template_id == null && modelType != 2">
            <template #button>
                <div class="w-fit flex items-center icon-hover text-grey-900 hover:text-grey-700">
                    <IconPlus class="w-4.5 h-4.5" />
                    <p class="pt-0.5 text-15 pl-2">Add attachment</p>
                </div>
            </template>

            <template #menu>
                <div class="table-multi-select-menu bg-black min-w-[198px]">
                    <template v-if="filesForFolder == null">
                        <template v-for="folder in _options?.folders ? _options.folders : options.model.folders">
                            <button class="flex items-center icon-hover-grey" type="button" @click="filesForFolder = folder.id">
                                <IconFolder class="w-4.5 h-4.5" />
                                <p class="pl-2">
                                    {{ $help.capitalizeFirstLetter(folder.name) }}
                                </p>
                            </button>
                        </template>
                        <!-- <button class="flex items-center" type="button">
                                <IconAttachFile class="w-4.5 h-4.5 stroke-grey-900" />
                                <p class="pl-2">Upload</p>
                            </button> -->
                    </template>
                    <template v-if="filesForFolder != null">
                        <button class="flex items-center" type="button" @click="filesForFolder = null">
                            <IconArrowLeft class="w-4.5 h-4.5 stroke-grey-900" />
                            <p class="pl-2">Back</p>
                        </button>
                        <template v-for="(upload, ui) in _options.uploads.filter((f) => f.folder_id == filesForFolder)">
                            <button class="flex items-center whitespace-nowrap" type="button" @click="attachUpload(upload)" data-close>
                                <component
                                    :is="color(upload) == 'doc' ? 'IconNote' : 'IconPhotos'"
                                    class="stroke-grey-800"
                                    :class="{
                                        'h-4 w-4': color(upload) == 'doc',
                                        'w-4 h-4': color(upload) == 'img',
                                    }"
                                />
                                <p class="pl-2">
                                    {{ upload.name }}
                                </p>
                            </button>
                        </template>
                    </template>
                </div>
            </template>
        </DropdownV2>

        <div class="flex flex-wrap gap-x-4 gap-y-2 mt-2" v-if='false'>
            <button
                class="w-fit flex items-center icon-hover text-grey-900 hover:text-grey-700 h-8"
                type="button"
                v-for="(upload, ui) in value.attachments"
                @click="value.attachments.splice(ui, 1)"
            >
                <EmailAttachment :upload="upload" />
            </button>
        </div>

        <div class="grid grid-cols-1 gap-3 mt-4" v-if='_options?.deals'>
            <CanHaveDeal :contactId="contactId" :modelId="modelId" :modelType="modelType" :deals="_options.deals" />
        </div>

        <template v-else>
            <input type="hidden" :value="contactId" name="belongs_id" />
            <input type="hidden" :value="options.modelType || modelType" name="belongs_type" />
        </template>
        

        <div class="grid grid-cols-2 lg:grid-cols-4 pt-8 gap-3">
            <ButtonSaving :disabled="saving" class="button-black h-12 col-span-2" name="published_at" value="1"> Send email </ButtonSaving>

            <button
                v-if="editingModel == null || editingModel.published_at == null"
                :disabled="saving"
                :value="null"
                class="button-purple h-12 col-span-2 lg:col-span-1"
                name="published_at"
            >
                Save draft
            </button>
        </div>
    </ModalFormCard>
</template>

<script>
import Email from '~/models/email.js'
import Modal from '~/mixins/modal.js'
import CanHaveDeal from '~/components/customer/blocks/can-have-deal.vue'
import EmailAttachment from '~/components/customer/blocks/email-attachment.vue'

export default {
    mixins: [Modal],

    created() {
        // this.requiresCRMFunds()+

        if (this.modelType == 2) {
            this.getTemplates();
        }

        this.setup(Email)

        if (this.options?.replyId) {
            this.value.subject = this.options.subject
            this.value.sent_to_email_address = this.options.sent_to_email_address
        }

        if (this.options.selectedValueId != null) {
            this.value.sent_to_email_address = this.numberOptions.find((n) => n.id == this.options.selectedValueId).value
        }

        if (this.options.email != null) {
            this.value.sent_to_email_address = this.options.email
        }
    },

    data() {
        return {
            filesForFolder: null,
            templates: null
        }
    },

    methods: {
        getTemplates() {
            this.$axios.get('/admin/actions/get-email-templates')
                .then(res => this.templates = res);
        },

        setTemplate() {
            // let t = this.templates.find(tm => tm.id == this.value.template_id)
           
            this.$axios.post('/admin/actions/set-email-templates/' + this.modelId, {
                template_id: this.value.template_id,
                email: this.value.sent_to_email_address
            })
                .then(res => {
                    console.log(res)
                    this.value.subject = res.subject
                    this.value.body = res.body
                })
        },

        attachUpload(upload) {
            this.value.attachments.push(upload)
        },

        color(upload) {
            let ext = upload.file_name.split('.')
            if (ext.length == 0) {
                return 'doc'
            }
            ext = ext[ext.length - 1]

            return ['jpg', 'png', 'jpeg', 'svg', 'gif'].indexOf(ext) >= 0 ? 'img' : 'doc'
        },
    },

    computed: {
        numberOptions() {
            if (this.modelType == 2) {
                let model = this.options.model != null ? this.options.model : this._options.model;
                let options = [];

                for (let u in model.users) {
                    let user = model.users[u]
                    let html = user.fullName() + ' - ';

                    if (user.job_title != null) {
                        html += user.job_title + ' - ';
                    }

                    options.push({
                        html: html + user.email,
                        value: user.email,
                        id: user.id
                    });
                }

                return options;
            }

            if (this._options?.communications) { 
                return this._options.communications
                    .filter((c) => c.type == 1)
                    .map((n) => {
                        return {
                            html: n.value,
                            value: n.value,
                            id: n.id,
                        }
                    })
            } else {
                return this.options.model.communications
                    .filter((c) => c.type == 1)
                    .map((n) => {
                        return {
                            html: n.value,
                            value: n.value,
                        }
                    })
            }
        },

        contactId() {
            if (this.editingModel != null && parseInt(this.editingModel.belongs_type) == 103) {
                return this.editingModel.belongs.contact_id
            }

            return this.editingModel?.belongs_id || this.modelId                
        },

        primaryEmailId() {
            if (this.modelType == 2) {
                return this.options.model.user.id
            }

            return this._options.model.primary_email;
        }
    },

    components: {
        CanHaveDeal,
        EmailAttachment,
    },
}
</script>
